"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_PLATFORM_DOMAIN = 'wixmp-3dbd5cb16bb136182e099f78.wixmp.com';
exports.FILES_MEDIA_PLATFORM_HOST = "https://" + exports.MEDIA_PLATFORM_DOMAIN;
exports.IMAGES_MEDIA_PLATFORM_HOST = "https://images-" + exports.MEDIA_PLATFORM_DOMAIN;
//# sourceMappingURL=endpoints.js.map